'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { getPathWithoutLocale } from '@/lib/i18n';

export function useScrollRestoration() {
    const pathname = usePathname();
    
    useEffect(() => {
        const pathWithoutLocale = getPathWithoutLocale(pathname || '/');
        const prevPath = sessionStorage.getItem('prevPathOnLangSwitch');
        const isLangSwitch = prevPath !== null && prevPath === pathWithoutLocale;
        const hasLangSwitchScroll = sessionStorage.getItem('scrollY_onLangSwitch') !== null;

        if (!isLangSwitch && !hasLangSwitchScroll) {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }

        sessionStorage.removeItem('prevPathOnLangSwitch');
    }, [pathname]);
}
